const {
  VITE_BASE_HOST,
  VITE_ENABLE_GOOGLE_MAPS_AUTOCOMPLETE,
  VITE_IDLE_TIMEOUT_MINUTES_FC
} = import.meta.env;

const IS_AUTOCOMPLETE_ENABLED = VITE_ENABLE_GOOGLE_MAPS_AUTOCOMPLETE === 'true';
const IDLE_TIMEOUT_MINUTES_FC = +VITE_IDLE_TIMEOUT_MINUTES_FC || 10;

enum URL_ROUTES {
  HOME = '/',
  BASE_HOME = '/home',
  CART = '/cart',
  CHECKOUT = '/checkout',
  PERSONAL_DETAILS = '/checkout/personal-details',
  SHIPPING = '/checkout/shipping',
  SHIPPING_NOVIOS = '/checkout/shipping/novios',
  BILLING = '/checkout/billing',
  BILLING_ORDER_PROCESSING_SUCCESS_PATH = '/checkout/billing/order/processing',
  BILLING_CONFIRM_ORDER_INTENT_PATH = '/checkout/billing/:id',
  BUY_NOW = '/checkout/buy-now',
  WEDDING_PERSONAL_DETAILS = '/checkout/novios/:weddingId/personal-details',
  WEDDING_BILLING_PATH = '/checkout/novios/:weddingId/billing',
  WEDDING_ORDER_PROCESSING_SUCCESS_PATH = '/checkout/novios/:weddingId/billing/order/processing',
  BILLING_CONFIRM_ORDER_INTENT_PATH_WEDDING = '/checkout/novios/:weddingId/billing/:id',
  MARKETPLACE_TERMS_LINK = 'https://www.paris.cl/informaciones-legales/terminos-y-condiciones-marketplace/',
  PARIS_TERMS_LINK = 'https://www.paris.cl/informaciones-legales/terminos-y-condiciones/',
  PRIVACY_POLICY_LINK = 'https://www.paris.cl/informaciones-legales/politica-privacidad-de-datos/',
  NOVIOS_PARIS_PATH = 'https://club.noviosparis.cl/home',
  DOWNLOAD_CENCOPAY_ANDROID = 'https://play.google.com/store/apps/details?id=com.cencosud.cencopay',
  DOWNLOAD_CENCOPAY_IOS = 'https://apps.apple.com/cl/app/cencopay-tu-billetera-digital/id6443818348',
  WHATSAPP_LINK = 'https://wa.me/56964963826',
  WEDDING_HOME = 'https://www.noviosparis.cl/home',
  PARIS_HOME_URL = 'https://www.paris.cl'
}

enum LOCAL_STORAGE_KEYS {
  DEVICE = 'device'
}

enum QUERY_PARAMS {
  DEVICE = 'device',
  TOKEN_WS = 'token_ws',
  TBK_TOKEN = 'TBK_TOKEN'
}

const REGION_HOST = `${import.meta.env.VITE_PUBLIC_BROWSER_BASE_HOST || 'https://be-paris-backend-cl-bff-browser-dev.ecomm-stg.cencosud.com'}/global/geo/cities`;
const SESSION_MANAGER_HOST = `${VITE_BASE_HOST || 'https://be-paris-backend-cl-ms-api-dev.ccom-stg.paris.cl'}/session/api`;

// Default values
export const DEFAULT_COMMUNE = '13114';
export const DEFAULT_COMMUNE_NAME = 'Las Condes';
export const DEFAULT_INTERNAL_COLLECT_ALIAS = 'INTERNAL_COLLECT';
export const DEFAULT_PREFIX_PHONE = '+56';
export const DEFAULT_REGION = 13;
export const DEFAULT_REGION_NAME = 'Metropolitana de Santiago';
export const INTANGIBLE_KEY = 'intangibles';

export const DNI_MIN_LENGTH = 8;
export const DNI_MAX_LENGTH = 18;

export const PHONE_PREFIX_OPTIONS = [
  { value: '+56', label: 'Chile (+56)' },
  { value: '+54', label: 'Argentina (+54)' },
  { value: '+55', label: 'Brasil (+55)' },
  { value: '+51', label: 'Perú (+51)' },
  { value: '+598', label: 'Uruguay (+598)' }
];

export {
  IDLE_TIMEOUT_MINUTES_FC,
  IS_AUTOCOMPLETE_ENABLED,
  LOCAL_STORAGE_KEYS,
  QUERY_PARAMS,
  REGION_HOST,
  SESSION_MANAGER_HOST,
  URL_ROUTES
};

export enum EDevice {
  WEB = 'web',
  ANDROID = 'android',
  IOS = 'ios',
  KIOSCO = 'kiosco'
}

export const noEmojiRegexExp: RegExp =
  /(\u00a9|\u00ae|[\u2000-\u3300]|\ud83c[\ud000-\udfff]|\ud83d[\ud000-\udfff]|\ud83e[\ud000-\udfff])/gi;
